var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ModelService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ReactComponent as TimeIconSVG } from '../../assets/images/global/hpms-time.svg';
import { ReactComponent as CheckGrayIconSVG } from '../../assets/images/global/check-blue.svg';
import { ReactComponent as CheckIconSVG } from '../../assets/images/global/check-green.svg';
import laboratoryIconSVG from '../../assets/images/avatars/avatar_lab.svg';
import './card-exams-lab-details-list-item.css';
let CardExamsLabDetailsListItem = class CardExamsLabDetailsListItem extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        onClick
                    }
                }));
            }
        };
    }
    getSvg() {
        const { status } = this.props;
        if (status == 'A' || status == 'R') {
            return React.createElement(CheckIconSVG, { className: 'status-icon' });
        }
        if (status == 'P') {
            return React.createElement(TimeIconSVG, { className: 'status-icon' });
        }
        return React.createElement(CheckGrayIconSVG, { className: 'status-icon' });
    }
    getExpression() {
        const { status } = this.props;
        if (status == 'A' || status == 'R') {
            return MessageService.translate('result.available');
        }
        if (status == 'P') {
            return MessageService.translate('result.processing');
        }
        return '';
    }
    renderAvatar() {
        return (React.createElement("div", { className: 'class-card-avatar' },
            React.createElement(Avatar, { image: laboratoryIconSVG })));
    }
    renderRightContent() {
        return (React.createElement("div", { className: 'card-right-content' },
            React.createElement("div", { className: 'content-status' },
                this.getSvg(),
                React.createElement("div", { className: 'content-text-status' }, this.getExpression()))));
    }
    render() {
        const { status, nmExame, dtProcedimento, dtExame } = this.props;
        const dsDate = status === 'P' ? dtProcedimento : dtExame;
        const dateText = status === 'A' || status === 'R' ? 'result.available-on' : '';
        return (React.createElement(Card, { onClick: () => this.onClick(), width: 12, className: 'card-exams-lab-details-list-item', selectionType: SelectionType.SINGLE, uuid: "cc12ce28-962b-4bd0-9d7c-22ddf6707e3c" },
            React.createElement("div", { className: `card-status-bar ${status}` }),
            React.createElement("div", { className: 'card-avatar' }, this.renderAvatar()),
            React.createElement("div", { className: 'card-content' },
                React.createElement("div", { className: 'card-left-content' },
                    React.createElement("div", { className: 'card-left-info-content' },
                        React.createElement("div", { className: 'content-exame-name' }, nmExame),
                        React.createElement("div", { className: 'content-physician-name' },
                            MessageService.translate(dateText),
                            " ",
                            ModelService.format('date', dsDate))),
                    React.createElement("div", { className: 'content-date' }, ModelService.format('date', dtProcedimento))),
                this.renderRightContent())));
    }
};
CardExamsLabDetailsListItem.propTypes = {
    onClick: eventListener,
    nmExame: string,
    dtProcedimento: string,
    status: string,
    type: string,
    nrPrescricao: number,
    dtExame: string
};
CardExamsLabDetailsListItem = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardExamsLabDetailsListItem);
export default CardExamsLabDetailsListItem;
//# sourceMappingURL=card-exams-lab-details-list-item.js.map